<div
    [agprLoading]="loading"
    class="agpr-passwordReset-container"
>
    <div
        *ngIf="mode === modes.RESET"
        class="agpr-passwordReset-header-container"
    >
        <div class="agpr-passwordReset-header-logo-container  {{ reseller }}" *ngIf="logoUrl">
            <div class="agpr-passwordReset-header-logoContainer" *ngIf="!logoRouterLink">
                <img
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                    class="agpr-passwordReset-header-logo"
                />
            </div>
            <a class="agpr-passwordReset-header-logoContainer" *ngIf="logoRouterLink" [href]="logoRouterLink">
                <img
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                    class="agpr-passwordReset-header-logo"
                />
            </a>
        </div>
    </div>

    <div
        *ngIf="mode === modes.SET"
        class="agpr-passwordReset-welcome"
    >
        <div class="agpr-passwordReset-welcome-header">
            <span
                role="img"
                aria-hidden="true"
                class="fa-kit-duotone fa-agpr-welcome"
            ></span>
            {{'PasswordReset.welcome.header' | localize: {name: firstName} }}
        </div>
        <div class="agpr-passwordReset-welcome-message">
            {{'PasswordReset.welcome.message' | localize}}
        </div>
    </div>

    <div class="agpr-passwordReset-body-container">

        <div
            *ngIf="!resetCompleted"
            class="agpr-passwordReset-body-header"
        >
            <h1
                *ngIf="mode !== modes.SET"
                class="agpr-passwordReset-body-header-title"
            >
                {{ (mode === modes.CHANGE ? 'PasswordReset.change.header' : 'PasswordReset.header') | localize}}
            </h1>
            <agpr-message
                *ngIf="apiError"
                [severity]="messageSeverities.error"
            >
                <div [innerHTML]="apiError | localize"></div>
            </agpr-message>
        </div>

        <div
            *ngIf="!resetCompleted"
            [formGroup]="passwordResetForm"
            class="agpr-passwordReset-body-content"
        >
            <div class="agpr-passwordReset-body-middle">
                <div class="agpr-passwordReset-body-inputs">
                    <div class="agpr-passwordReset-body-inputs-row">
                        <label  class="agpr-passwordReset-body-username-label">{{ 'PasswordReset.username' | localize }}</label>
                        <div class="agpr-passwordReset-body-username">
                            {{ username }}
                        </div>
                        <!-- HACK to get aroud chrome autofill which will populate the input immediately preceeding
                        the password input with an email regardless of autocomplete attribute value - in this case
                        its the account search input in the nav -->
                        <input class="dummy" aria-hidden="true" tabindex="-1"/>
                    </div>

                    <ng-container *ngIf="(mode === modes.CHANGE || mode === modes.SET)">
                        <div class="agpr-passwordReset-body-inputs-row">
                            <agpr-text-input
                                formControlName="currentPassword"
                                [id]="'passwordReset_currentPassword_input'"
                                [type]="current.type"
                                [label]="mode === modes.SET ? 'PasswordReset.currentTempPassword' : 'PasswordReset.currentPassword'"
                                autocomplete="current-password"
                                [required]="true"
                                [iconClickable]="true"
                                [icon]="(current.type === inputTypes.PASSWORD ? 'fa-eye fa-duotone' : 'fa-eye-slash fa-duotone')"
                                [iconClickableTooltip]="current.type === inputTypes.PASSWORD ? 'PasswordReset.showPassword' : 'PasswordReset.hidePassword'"
                                (iconClick)="current.toggleVisibility()"
                                (focus)="hidePasswords(current)"
                            ></agpr-text-input>
                        </div>
                    </ng-container>

                    <div class="agpr-passwordReset-body-inputs-row">
                        <agpr-text-input
                            formControlName="newPassword"
                            [id]="'passwordReset_newPassword_input'"
                            [type]="newPass.type"
                            label="PasswordReset.newPassword"
                            autocomplete="new-password"
                            [ariaInvalid]="newPasswordFormControl.dirty && !newPasswordFormControl.valid"
                            ariaDescribedBy="validation_rules"
                            [required]="true"
                            [iconClickable]="true"
                            [icon]="(newPass.type === inputTypes.PASSWORD ? 'fa-eye fa-duotone' : 'fa-eye-slash fa-duotone')"
                            [iconClickableTooltip]="newPass.type === inputTypes.PASSWORD ? 'PasswordReset.showPassword' : 'PasswordReset.hidePassword'"
                            (iconClick)="newPass.toggleVisibility()"
                            (focus)="hidePasswords(newPass)"
                        ></agpr-text-input>
                    </div>

                    <div class="agpr-passwordReset-body-inputs-row">
                        <agpr-text-input
                            formControlName="confirmPassword"
                            [id]="'passwordReset_confirmPassword_input'"
                            [type]="confirm.type"
                            label="PasswordReset.confirmNewPass"
                            autocomplete="off"
                            [ariaInvalid]="!!passwordResetForm.errors"
                            ariaDescribedBy="match_rule"
                            [required]="true"
                            [iconClickable]="true"
                            [icon]="(confirm.type === inputTypes.PASSWORD ? 'fa-eye fa-duotone' : 'fa-eye-slash fa-duotone')"
                            [iconClickableTooltip]="confirm.type === inputTypes.PASSWORD ? 'PasswordReset.showPassword' : 'PasswordReset.hidePassword'"
                            (iconClick)="confirm.toggleVisibility()"
                            (focus)="hidePasswords(confirm)"
                            (keyup)="resetOnEnter($event)"
                        ></agpr-text-input>
                    </div>

                </div>
                <div id="validation_rules" class="agpr-passwordReset-body-passwordrules">
                    <div class="agpr-passwordReset-body-passwordrules-header">
                        <h2 class="agpr-headerH2-upper">{{'PasswordReset.passwordRules' | localize}}</h2>
                    </div>
                    <div class="agpr-passwordReset-body-passwordrules-validation">
                        <ul>
                            <li>
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!newPass?.value ? 'fa-circle-small' : newPasswordErrors?.['minlength'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(newPasswordErrors?.['minLength']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.minLength' | localize}}
                            </li>
                            <li>
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!newPass?.value ? 'fa-circle-small' : newPasswordErrors?.['special'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(newPasswordErrors?.['special']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.special' | localize}}
                            </li>
                            <li>
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!newPass?.value ? 'fa-circle-small' : newPasswordErrors?.['number'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(newPasswordErrors?.['number']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.number' | localize}}
                            </li>
                            <li>
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!newPass?.value ? 'fa-circle-small' : newPasswordErrors?.['uppercase'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(newPasswordErrors?.['uppercase']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.uppercase' | localize}}
                            </li>
                            <li>
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!newPass?.value ? 'fa-circle-small' : newPasswordErrors?.['lowercase'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(newPasswordErrors?.['lowercase']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.lowercase' | localize}}
                            </li>
                            <li id="match_rule">
                                <span
                                    role="img"
                                    class="fa rule-icon"
                                    [ngClass]="!confirm?.value ? 'fa-circle-small' : passwordResetForm.errors?.['passwordsMismatch'] ? 'fa-close' : 'fa-check'"
                                    [attr.aria-label]="(passwordResetForm.errors?.['passwordsMismatch']
                                    ? 'PasswordReset.passwordRules.invalid'
                                    : 'PasswordReset.passwordRules.valid') | localize"
                                ></span>
                                {{'PasswordReset.passwordRules.match' | localize}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="resetCompleted"
            class="agpr-passwordReset-body-content agpr-passwordReset-body-complete"
        >
            <h1
                class="agpr-headerH1-darkSmaller"
            >
                {{ (mode === modes.CHANGE ? 'PasswordReset.change.header' : 'PasswordReset.header') | localize}}
            </h1>
            <div>{{'PasswordReset.resetConfirmation' | localize}}</div>
            <div
                class="agpr-passwordReset-body-button"
            >
                <agpr-button
                    [id]="'passwordReset_login_button'"
                    primary="true"
                    label="PasswordReset.login"
                    (click)="backToLogin()"
                    [style]="buttonTypes.secondary"
                ></agpr-button>
            </div>
        </div>
    </div>

    <div
        *ngIf="!resetCompleted"
        class="agpr-passwordReset-footer"
    >
        <agpr-action-bar>
            <ng-template #right>
                <agpr-button
                    [id]="'passwordReset.reset.button'"
                    label="PasswordReset.change.button"
                    primary="true"
                    [style]="buttonTypes.primary"
                    [disabled]="!passwordResetForm.valid"
                    [tooltip]="!passwordResetForm.valid ? disabledTooltip : null"
                    (click)="reset()"
                >
                </agpr-button>
            </ng-template>
        </agpr-action-bar>
    </div>
</div>
